















































































































































































































































































































































































































































import { Component, Inject, Prop, Ref, Vue } from 'vue-property-decorator'
import { ReferralAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { bgLayer, overlayLayer } from '@geo-frontend/nlmaps/dist/nlmaps-googlemaps.es'

@Component
export default class EmmaAppraisal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Inject() reloadReferral!: () => Promise<void>
    manualValuation: number = null
    manualValuationVisible: boolean = false
    savingManualValuation: boolean = false
    housetype: string = null
    editingHousetype: boolean = false
    savingHousetype: boolean = false
    @Ref() map
    showMoreReferenceTransactions: boolean = false

    mounted() {
        this.initManualValuation()
        this.initHousetype()
        this.initMap()
    }

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    initManualValuation() {
        if (this.manualValuationData && this.manualValuationData.valuation) {
            this.manualValuation = this.manualValuationData.valuation
        } else {
            this.manualValuation = this.medianValuation
        }
    }

    async saveManualValuation() {
        this.savingManualValuation = true
        await ReferralAPI.updateManualValuationData(
            this.referral.id,
            this.manualValuation,
            this.$currentUser,
        )
        this.savingManualValuation = false

        this.reloadReferral()
    }

    initHousetype() {
        if (this.valuationData && this.valuationData.type) {
            this.housetype = this.valuationData.type
        } else {
            this.housetype = null
        }
    }

    async saveHousetype() {
        this.savingHousetype = true
        await ReferralAPI.updateHousetypeData(
            this.referral.id,
            this.housetype,
        )
        this.savingHousetype = false

        this.reloadReferral()
    }

    get validHousetypes() {
        return [
            'Vrijstaande woning',
            '2 onder 1 kap woning',
            'Geschakelde 2 onder 1 kapwoning',
            'Geschakelde woning',
            'Tussen/rijwoning',
            'Hoekwoning',
            'Eindwoning',
            'Galerijflat',
            'Portiekflat',
            'Corridorflat',
            'Maisonnette',
            'Benedenwoning',
            'Bovenwoning',
            'Portiekwoning',
        ].map(housetype => {
            return {
                label: housetype,
                value: housetype,
            }
        })
    }

    initMap() {
        if (!this.map) {
            return
        }

        this.map.$mapPromise.then(map => {
            const nlmapsBgLayer = bgLayer(map, 'pastel')
            map.mapTypes.set(nlmapsBgLayer.name, nlmapsBgLayer)
            map.setMapTypeId(nlmapsBgLayer.name)

            const nlmapsOverlayLayer = overlayLayer(map, 'percelen')
        })
    }

    get addressData() {
        if ('address' in this.referral.data) {
            return this.referral.data.address
        }

        return null
    }

    get address(): string {
        if (!this.addressData) {
            return null
        }

        let address = ''

        if (this.addressData.streetname && this.addressData.streetname.length > 0) {
            address = address.trim()
            address += ` ${this.addressData.streetname}`
        }

        if (this.addressData.streetnumber && this.addressData.streetnumber.length > 0) {
            address = address.trim()
            address += ` ${this.addressData.streetnumber}`
        }

        if (this.addressData.streetnumbersuffix && this.addressData.streetnumbersuffix.length > 0) {
            address = address.trim()
            address += ` ${this.addressData.streetnumbersuffix}`
        }

        if (this.addressData.city && this.addressData.city.length > 0) {
            address = address.trim()
            address += `, ${this.addressData.city}`
        }

        return address
    }

    get imageUrl(): string {
        if (!this.addressData || !this.addressData.imagePath) {
            return
        }

        return process.env.VUE_APP_KEYVUE_BACKEND_BASEURL
            + '/attachments/'
            + this.addressData.imagePath
    }

    get manualValuationData() {
        if ('manualValuation' in this.referral.data) {
            return this.referral.data.manualValuation
        }

        return null
    }

    get valuationData() {
        if ('valuation' in this.referral.data) {
            return this.referral.data.valuation
        }

        return null
    }

    get minValuation(): number|null {
        if (!this.valuationData) {
            return null
        }

        return Number.parseFloat(this.valuationData.minValuation)
    }

    get medianValuation(): number|null {
        if (!this.valuationData) {
            return null
        }

        return Number.parseFloat(this.valuationData.medianValuation)
    }

    get maxValuation(): number|null {
        if (!this.valuationData) {
            return null
        }

        return Number.parseFloat(this.valuationData.maxValuation)
    }

    get valuationDate(): string|null {
        if (!this.valuationData) {
            return null
        }

        return this.valuationData.valuationDate
    }

    get confidence(): string|null {
        if (!this.valuationData) {
            return null
        }

        return this.valuationData.confidence
    }

    get wozValuesData() {
        if ('wozValues' in this.referral.data) {
            return this.referral.data.wozValues
        }

        return null
    }

    get wozValue(): number|null {
        if (!this.wozValuesData || this.wozValuesData.wozValues.length === 0) {
            return null
        }

        return Number.parseFloat(this.wozValuesData.wozValues[this.wozValueDate])
    }

    get wozValueDate() {
        if (!this.wozValuesData || this.wozValuesData.wozValues.length === 0) {
            return null
        }

        return this.wozValueDates[0]
    }

    get wozValueDates() {
        if (!this.wozValuesData || this.wozValuesData.wozValues.length === 0) {
            return null
        }

        return Object.keys(this.wozValuesData.wozValues)
            .sort((a, b) => {
                return this.$options.filters.date(b, 'YYYY') - this.$options.filters.date(a, 'YYYY')
            })
    }

    get referenceTransationsData() {
        if ('referenceTransations' in this.referral.data) {
            return this.referral.data.referenceTransations
        }

        return null
    }

    get referenceTransactions() {
        if (!this.referenceTransationsData) {
            return []
        }

        return this.referenceTransationsData
    }

    get visibleReferenceTransactions() {
        if (this.showMoreReferenceTransactions) {
            return this.referenceTransactions
        } else {
            return this.referenceTransactions.slice(0, 5)
        }
    }

    get locationData() {
        if ('location' in this.referral.data) {
            return this.referral.data.location
        }

        return null
    }

    get houseTypes(): string[] {
        if (!this.locationData || !this.locationData.zipcodeData) {
            return []
        }

        return Object.keys(this.locationData.zipcodeData.HouseTypes)
    }

    get filteredHouseTypes(): string[] {
        return this.houseTypes.filter(houseType => {
            return this.locationData.zipcodeData.HouseTypes[houseType] > 0
        })
    }

    get mapPosition() {
        if (this.valuationData) {
            return {
                lat: this.valuationData.latitude,
                lng: this.valuationData.longitude,
            }
        }

        if (this.addressData) {
            return {
                lat: this.addressData.latitude,
                lng: this.addressData.longitude,
            }
        }

        return null
    }

    get mapOptions() {
        return {
            disableDefaultUI: true,
            styles: [
                {
                    featureType: 'poi',
                    stylers: [{visibility: 'off'}],
                },
            ],
        }
    }

    formatValuation(valuation: number): string {
        return Number(valuation).toLocaleString('nl', { maximumFractionDigits: 0, style: 'currency', currency: 'EUR' })
    }

    formatQuantity(quantity: string|number, digits: number = 0): string {
        return Number(quantity).toLocaleString('nl', { maximumFractionDigits: digits }        )
    }
}
